export const saveInfo = "SAVEINFO";

export const saveInfoData = (data,toAPI=true) => {
    return {
        type: saveInfo,
        payload: data,
        toAPI: toAPI
    };
};
